export enum CheckCleanupResult {
  Ok = 0,
  TransactionsInBuffer = 1,
  TransactionsPendingConfirmation = 2
}
